import { render, staticRenderFns } from "./ArtifactVersionDetail.vue?vue&type=template&id=3bef20d8&scoped=true"
import script from "./ArtifactVersionDetail.vue?vue&type=script&lang=js"
export * from "./ArtifactVersionDetail.vue?vue&type=script&lang=js"
import style0 from "./ArtifactVersionDetail.vue?vue&type=style&index=0&id=3bef20d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef20d8",
  null
  
)

export default component.exports